/*
 * Project: Bookingengine
 * Module: Payment.js
 * @flow
 */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  requestTPVForm,
  bookingAdyenPay,
  setBookLocator,
  initializeSignalR,
} from '../../../actions/Booking';
import withNavigate from '../../../withNavigate'; // Importa el HOC

import PaymentBookDetails from './PaymentBookDetails';
import PaymentMethods from './PaymentMethods';

import {
  TPV_FORM_DEFAULT_METHOD, TPV_FORM_ADYEN, TPV_FORM_UPFRONT_PAYMENT_METHOD, TPV_FORM_UPFRONT_ADYEN_PAYMENT_METHOD,
} from '../../../constants';
import { store } from '../../../Store';

class PaymentBooking extends React.Component {
  constructor(props) {
    super(props);

    this.props.dispatch(setBookLocator(this.props.booking.locator));
    const { booking } = props;
    this.state = {
      jumping: false,
      selectedCard: booking.card_type,
      selectedMethod: booking.hotel.payment_methods.filter((p) => p.is_tpv === true)[0],
    };
  }

  onSelectMethod = (method) => {
    if (!this.state.jumping) {
      this.setState({ selectedMethod: method });
    }
  };

  onJumpToTPV = async () => {
    this.setState({ jumping: true });

    if (this.props.formMethod === TPV_FORM_DEFAULT_METHOD && this.state.selectedMethod.code === 'ADYEN') {
      const state = store.getState();
      this.props.dispatch(initializeSignalR(this.props.navigate,
        this.props.location,
        state.session.chainData.signalr_server,
        state.bookingFormState.sessionId,
        this.props.booking.locator));
      await this.props.dispatch(bookingAdyenPay(this.context,
        this.props.booking.locator,
        this.props.booking.cli_email,
        TPV_FORM_ADYEN,
        this.props.navigate));
    } else if (this.props.formMethod === TPV_FORM_UPFRONT_PAYMENT_METHOD
        && this.state.selectedMethod.code === 'ADYEN') {
      const state = store.getState();
      this.props.dispatch(initializeSignalR(this.props.navigate,
        this.props.location,
        state.session.chainData.signalr_server,
        state.bookingFormState.sessionId,
        this.props.booking.locator));
      await this.props.dispatch(bookingAdyenPay(this.context,
        this.props.booking.locator,
        this.props.booking.cli_email,
        TPV_FORM_UPFRONT_ADYEN_PAYMENT_METHOD,
        this.props.navigate));
    } else {
      this.props
        .dispatch(
          requestTPVForm(
            this.props.formMethod || TPV_FORM_DEFAULT_METHOD,
            this.props.booking.locator,
            this.props.booking.cli_email,
            this.state.selectedMethod.code,
            this.state.selectedCard,
          ),
        );
    }
  };

  onSelectCard = (card) => {
    this.setState({ selectedCard: card.code });
  };

  render() {
    const { booking } = this.props;
    if (!booking) {
      return null;
    }

    const currency = { ...booking.currency, locale: this.props.lang };
    const tpvMethods = booking.hotel.payment_methods.filter((p) => p.is_tpv === true);
    return (
      <div className="PaymentBooking">
        <PaymentBookDetails booking={booking} currency={currency} />
        <PaymentMethods
          methods={tpvMethods}
          method={this.state.selectedMethod}
          onSelect={this.onSelectMethod}
          paymentCards={booking.hotel.payment_cards}
          cardSelected={this.state.selectedCard}
          onSelectCard={this.onSelectCard}
        />
        <button className="btn btn-primary PMButton" onClick={this.onJumpToTPV} disabled={this.state.jumping}>
          {this.state.jumping ? (
            <div>
              {this.context.t('Just one moment, please...')}
              <i className="fa fa-clock-o"/>
            </div>
          ) : (
            <div>
              {this.context.t('Proceed to the payment system')}
              <i className="fa fa-arrow-right"/>
            </div>
          )}
        </button>
        <div id="dropin-container"></div>
      </div>
    );
  }
}

PaymentBooking.propTypes = {
  formMethod: PropTypes.oneOf(['tpv-form', 'tpv-upfront-payment-form']),
};

PaymentBooking.defaultProps = {
  formMethod: TPV_FORM_DEFAULT_METHOD,
};

PaymentBooking.contextTypes = {
  t: PropTypes.func.isRequired,
};

const ConnectedPaymentBooking = connect()(PaymentBooking);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedPaymentBooking);
